import { ReactElement } from 'react';

import ROUTES from '@app/src/common/constants/routeUrls';

import CheckinIcon from '../assets/CheckIn.svg';
import DevicesIcon from '../assets/Devices.svg';
import CompanyIcon from '../assets/Company.svg';
import ProjectsIcon from '../assets/Projects.svg';
import ScheduleIcon from '../assets/Schedule.svg';
import StorageIcon from '../assets/Storage.svg';
import OrderIcon from '../assets/Order.svg';
import WayFindingIcon from '../assets/WayFinding.svg';
import RoomBookingIcon from '../assets/RoomBooking.svg';
import OtherIcon from '../assets/Other.svg';
import ParkingIcon from '../assets/Parking.svg';
import InventoryIcon from '../assets/Inventory.svg';
import FormIcon from '../assets/Form.svg';

export interface ISidebarRoute {
  labelId: string;
  Icon: () => ReactElement;
  order: number;
}

export const SIDEBAR_ROUTES: Record<string, ISidebarRoute> = {
  [ROUTES.deviceManagement.path]: {
    labelId: 'app.navigation.devices',
    Icon: DevicesIcon,
    order: 1
  },
  [ROUTES.contentManagement.path]: {
    labelId: 'app.navigation.content',
    Icon: ProjectsIcon,
    order: 2
  },
  [ROUTES.schedule.path]: {
    labelId: 'app.navigation.schedule',
    Icon: ScheduleIcon,
    order: 3
  },
  [ROUTES.fileStorage.path]: {
    labelId: 'app.navigation.storage',
    Icon: StorageIcon,
    order: 4
  },
  [ROUTES.userManagement.path]: {
    labelId: 'app.navigation.company',
    Icon: CompanyIcon,
    order: 5
  },
  [ROUTES.eventManagement.path]: {
    labelId: 'app.navigation.check.in',
    Icon: CheckinIcon,
    order: 6
  },
  [ROUTES.formManagement.path]: {
    labelId: 'app.navigation.form',
    Icon: FormIcon,
    order: 7
  },
  [ROUTES.parkingManagement.path]: {
    labelId: 'app.navigation.parking',
    Icon: ParkingIcon,
    order: 8
  },
  [ROUTES.wayFinding.path]: {
    labelId: 'app.navigation.way.finding',
    Icon: WayFindingIcon,
    order: 9
  },
  [ROUTES.orderManagement.path]: {
    labelId: 'app.navigation.order',
    Icon: OrderIcon,
    order: 10
  },
  [ROUTES.bookingManagement.path]: {
    labelId: 'app.navigation.room.signage',
    Icon: RoomBookingIcon,
    order: 11
  },
  [ROUTES.inventoryManagement.path]: {
    labelId: 'app.navigation.inventory',
    Icon: InventoryIcon,
    order: 12
  },
  [ROUTES.customSolutions.path]: {
    labelId: 'app.navigation.custom.solutions',
    Icon: OtherIcon,
    order: 13
  }
};
